import { render, staticRenderFns } from "./merchant-account-name.container.vue?vue&type=template&id=a0bc0d5c&scoped=true&lang=pug"
import script from "./merchant-account-name.container.vue?vue&type=script&lang=ts"
export * from "./merchant-account-name.container.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bc0d5c",
  null
  
)

export default component.exports